// Bu dosya artık kullanılmıyor. Ürünler API'den çekilecek.
export const products = []; 